import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M12 22c2.21 0 4-4.477 4-10S14.21 2 12 2m0 20c-2.21 0-4-4.477-4-10S9.79 2 12 2m0 20c5.523 0 10-4.477 10-10q0-.14-.004-.28M12 22C6.477 22 2 17.523 2 12q0-.14.004-.28M12 2c5.43 0 9.848 4.327 9.996 9.72M12 2c-5.43 0-9.848 4.327-9.996 9.72m19.992 0c-1.802 1.482-5.601 2.502-9.996 2.502s-8.194-1.02-9.996-2.501"
    />
  </svg>
);
export const IconGlobe = withDynamicStroke(Icon);
